/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module serves to export all library objects and object constructors with the `require("apg-lib")` statement.
// For example, to create a new parser in your program,
// ````
// let apglib = require("../apg-lib/node-exports");
// let my-parser = new apglib.parser();
// ````
module.exports = {
  ast: require('./ast'),
  circular: require('./circular-buffer'),
  ids: require('./identifiers'),
  parser: require('./parser'),
  stats: require('./stats'),
  trace: require('./trace'),
  utils: require('./utilities'),
  emitcss: require('./emitcss'),
  style: require('./style'),
};
